import React, { Component } from 'react';
import { Row, Col, Button, Alert, Container, Label, FormGroup } from "reactstrap";
import { connect } from 'react-redux';
import { withRouter, Link, Redirect } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { checkLogin, apiError } from '../../store/actions';
// import logodark from "../../assets/images/logo-dark.png";
import logo from "../../assets/images/logo.png";
import { login } from "../../services/authService";
import { notifyError, notifySuccess } from "../../utils/utils";
import Loader from "../../utils/Loader";

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            alertModel: false,
            alertMessage: "",
            username:"",
            password:"",
            loading: false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        const data = {
            username: this.state.username,
            password: this.state.password
        };

        this.setState({ loading: true });

        login(data)
        .then(data => {

            this.setState({ loading: false });
            
             if (data.status) {

                localStorage.setItem("token", data.token);
                localStorage.setItem("loggedIn", true);

                notifySuccess(data.message);
                // setTimeout(() => {
                    this.setState({
                        redirect: true
                    })
                // },2000);

            } else {
                
                notifyError(data.message);
                
            }

        });       
    }

    componentDidMount() {
        this.props.apiError("");
        document.body.classList.add("auth-body-bg");
    }

    componentWillUnmount() {
        document.body.classList.remove("auth-body-bg");
    }

    render() {

        if (this.state.redirect)
            return (
                <Redirect
                    to={"/dashboard"}
                />
            )

        return (
            <React.Fragment>
                <div className="home-btn d-none d-sm-block">
                    <Link to="/"><i className="mdi mdi-home-variant h2 text-white"></i></Link>
                </div>


                <div>
                    <Container fluid className="p-0">

                        <Row className="no-gutters">
                            <Col lg={4}>
                            </Col>
                            <Col lg={4}>

                                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                    <div className="w-100">
                                        <Alert color={this.state.alertType} isOpen={this.state.alertModel} toggle={this.toggleAlert}>
                                            {this.state.alertMessage}
                                        </Alert>
                                        <Row className="justify-content-center">
                                            <Col lg={9}>
                                                <div>
                                                    <div className="text-center">
                                                        <div>
                                                            <Link to="/" className="logo"><img src={logo} height="100" width="100" alt="logo" /></Link>
                                                        </div>
                                                                    <h3 className="font-size-18 mt-4 text-info">Admin Login</h3>
                                                                    {/* <p className="text-muted">Enter Mobile number to continue.</p> */}
                                                    </div>


                                                    {this.props.loginError && this.props.loginError ? <Alert color="danger">{this.props.loginError}</Alert> : null}

                                                    <div className="p-2 mt-5">
                                                        <AvForm className="form-horizontal" onValidSubmit={this.handleSubmit} >

                                                            <FormGroup className="auth-form-group-custom mb-4">
                                                                <i className=" ri-user-line auti-custom-input-icon"></i>
                                                                <Label htmlFor="mobile">Username</Label>

                                                                <AvField
                                                                    name="username"
                                                                    value={this.state.username}
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="username"
                                                                    onChange={e => {
                                                                        this.setState({
                                                                            username: e.target.value
                                                                        });
                                                                    }}
                                                                    validate={{
                                                                        required: { value: true },
                                                                    }}
                                                                    placeholder="Username"
                                                                />
                                                            </FormGroup>
                                                            <FormGroup className="auth-form-group-custom mb-4">
                                                                <i className=" ri-lock-password-line auti-custom-input-icon"></i>
                                                                <Label htmlFor="mobile">Password</Label>

                                                                <AvField
                                                                    name="password"
                                                                    value={this.state.password}
                                                                    type="password"
                                                                    className="form-control"
                                                                    id="password"
                                                                    onChange={e => {
                                                                        this.setState({
                                                                            password: e.target.value
                                                                        });
                                                                    }}
                                                                    validate={{
                                                                        required: { value: true },
                                                                    }}
                                                                    placeholder="Password"
                                                                />
                                                            </FormGroup>
                                                            <div className="mt-4 text-center">
                                                                {
                                                                    this.state.loading
                                                                        ?
                                                                        <Loader />
                                                                        // <Spinner style={{ width: '3rem', height: '3rem' }}  color="primary" />
                                                                        :
                                                                        <Button
                                                                            color="primary"
                                                                            className="w-md waves-effect waves-light"
                                                                            type="submit"
                                                                        >
                                                                            Log In
                                                                        </Button>
                                                                }
                                                                {/* <Button color="info" className="w-md waves-effect waves-light" type="submit">Submit</Button> */}
                                                            </div>
                                                        </AvForm>
                                                </div>


                                                </div>
                                            </Col>
                                        </Row>
                                </div>
                                </div>
                            </Col>
                        </Row>

                    </Container>

                </div>
            </React.Fragment >
        );
    }
}

const mapStatetoProps = state => {
    const { loginError } = state.Login;
    return { loginError };
}

export default withRouter(connect(mapStatetoProps, { checkLogin, apiError })(Login));